module.exports = __webpack_public_path__ + "img/figma.39916582.svg";